import React, { useContext, useEffect } from 'react';

function Logout() {

    useEffect(() => {
        localStorage.clear()
        window.location.href = "/";
    }, []);

    return <div>Odhlašování...</div>;
}

export default Logout;
